// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../subMinutes/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var subMinutes = convertToFP(fn, 2);
export default subMinutes;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/subMinutes/index.js
// module id = 1006
// module chunks = 0